import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import config from 'constants/apiConfig';
import axios from 'axios';

export const keys = {
  incidentWorkspaceTeamStatus: 'incidentWorkspaceTeamStatus',
};

export const useFetchIncidentWorkspaceTeamStatus = () => {
  const queryClient = useQueryClient();

  const incidentId = useSelector(
    (state: { app: { currentIncident: { id: UUID } } }) =>
      state.app.currentIncident.id
  );
  return useQuery({
    queryKey: [keys.incidentWorkspaceTeamStatus, incidentId],
    queryFn: async () => {
      const response = await axios(
        config.apiGateway.fetchIncidentStatus,{
            method: 'POST',
            data:
        {
          incidentId,
        }
    }

      );

      // conditionally initiate polling
      if (response?.data?.[0]?.teams_status === 'inprogress') {
        setTimeout(() => {
          queryClient.invalidateQueries({
            queryKey: [keys.incidentWorkspaceTeamStatus, incidentId],
          });
        }, 5000);
      }

      return response?.data?.[0]?.teams_status;
    },
  });
};
